<template>
  <div>
    <el-container>
      <el-header>
        <div class="header">流体力学软件</div>
      </el-header>
      <el-main>
        <div>
          <h3 class="title">选择一个问题</h3>
          <div class="content">
            <div class="wrap" @click="$selecQues">
              <img src="/static/img/bg-ques.png" alt />
              <p>泊松方程</p>
            </div>
          </div>
        </div>
      </el-main>
      <upload-dialog @toProject="$toProject"></upload-dialog>
    </el-container>
  </div>
</template>

<script>
import uploadDialog from '../../components/common/uploadDialog'

export default {
  name: 'index',
  components: {
    uploadDialog
  },
  data() {
    return {}
  },
  methods: {
    $selecQues() {
      this.$prompt('项目名称', '新建泊松方程项目', {
        confirmButtonText: '下一步',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputValue: '泊松方程-1',
        inputErrorMessage: '请输入项目名称'
      }).then(({ value }) => {
        // this.showUploadDialog(value)
        this.$router.push('project/project')
      })
    },
    showUploadDialog(val) {
      this.$root.$emit('showUploadDialog', val)
    },
    $toProject() {
      this.$router.push('project/project')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-header,
.el-footer {
  background: #f4f2f2;
  color: #333;
  font-size: 30px;
  line-height: 60px;
}
h3.title {
  font-size: 36px;
  line-height: 50px;
  text-align: center;
  font-weight: 600;
  color: #3294f8;
  margin: 30px 0;
}
.content {
  overflow: hidden;
  margin: 0 -15px;
  .wrap {
    width: 300px;
    margin: 0 15px;
    float: left;
    cursor: pointer;

    img {
      display: block;
      width: 100%;
      transition: 0.2s all;
      background: #f4f2f2;
    }

    p {
      font-size: 36px;
      line-height: 40px;
      text-align: center;
      color: #000000;
      margin-top: 20px;
    }
  }

  .wrap:hover img {
    box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.16);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue